<template>
  <div class="row">
    <div class="col-12">
      <filter-component />
      <table-component />
    </div>
  </div>
</template>

<script>
  import FilterComponent from './mailings-stats-detailed-table-filter';
  import TableComponent from './mailings-stats-detailed-table';

  export default {
    components: {
      FilterComponent,
      TableComponent
    }
  };
</script>